export const getMonthlyLoanPayment = (loans = []) => {
  if (loans.length === 0) {
    return 0;
  }

  const loansSorted = loans
    .filter((loan) => loan.payment_frequency === "m")
    .sort(
      (a, b) =>
        parseFloat(a.payment_per_interval) - parseFloat(b.payment_per_interval)
    );

  return parseFloat(loansSorted[0].payment_per_interval);
};
